function Shimmer() {
  return (
    <div className="mt-16 flex flex-wrap">
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-50 bg-gray-50"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-50 bg-gray-50"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-50 bg-gray-50"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-50 bg-gray-50"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-300 bg-gray-100"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-50 bg-gray-50"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-50 bg-gray-50"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-300 bg-gray-100"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-50 bg-gray-50"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-50 bg-gray-50"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-50 bg-gray-50"></div>
      <div className="m-2 p-4 w-[250px] h-[300px] rounded-lg border border-solid border-gray-50 bg-gray-50"></div>
    </div>
  );
}

export default Shimmer;
